import { useState, useEffect, useMemo } from 'react';
import { getParameter } from '@bingads-webui/url-util';
import { odata } from './odata';
import { getConfig } from './config';
import { GoogleTagManagerReporitory } from './gtm-repository';

const config = getConfig({
  // 'odata.token': null,
  // for sign up flow, these values are false
  ReadOnlyMode: false,
  CurrentAccountInActive: false,
});

export const useDependencies = ({
  serverContext,
  isDemo = false,
  testStubOdata,
}) => {
  const getParams = ({ CurrentUser, CurrentCustomer, CurrentAccount }) => {
    if (CurrentCustomer && CurrentAccount && CurrentUser) {
      const paramData = {
        account_id: CurrentAccount.Id,
        customer_id: CurrentCustomer.Id,
        advertisercustomer_id: CurrentAccount.AdvertiserCustomerID,
        user_id: CurrentUser.Id,
      };
      return paramData;
    }
    return null;
  };

  const [testToken, setTestToken] = useState(null);
  const [deps, setDeps] = useState(null);
  const [odataInstance, setOdataInstance] = useState(null);
  const [repository, setRepository] = useState(null);

  useEffect(() => {
    if (!odataInstance && !isDemo) {
      const {
        CurrentLocale,
        CultureLcid,
        ServicesEndpoints,
        CampaignAPIPath,
        Token,
        CurrentAccount,
        CurrentCustomer,
        CurrentUser,
      } = serverContext;
      const odataUrl = ServicesEndpoints && ServicesEndpoints.CampaignAPI;
      const isOnebox = odataUrl && odataUrl.toString().indexOf('redmond.corp') > 0;
      config.set({
        CultureName: CurrentLocale,
        CultureLcid,
        'odata.url': odataUrl, // https://ui.ads-int.microsoft.com/ODataApi
        'odata.path': CampaignAPIPath || isOnebox ? '/Advertiser/V2' : '/Campaign/V2', // /Campaign/V2 for all env except onebox
        'odata.token': Token,
        CurrentUser,
        CurrentCustomer,
        CurrentAccount,
        AccountTimeZone: (CurrentAccount && CurrentAccount.TimeZone) || 71,
      });

      if (isDemo) {
        setOdataInstance(testStubOdata);
      } else if (serverContext.CurrentAccount) {
        const params = getParams(serverContext);
        setOdataInstance(odata(config, params));
      }
    }
  }, [isDemo, odataInstance, serverContext, testStubOdata]);

  useEffect(() => {
    if (odataInstance) {
      let token = null;
      const isselenium = getParameter('isselenium');
      const testAccount = getParameter('testAccount');
      if (isselenium && testAccount) {
        token = getParameter('token');
        setTestToken(token);
      }
      const dependencies = {
        odata: odataInstance,
        permissions: serverContext.Permissions,
      };
      setDeps(dependencies);
      setRepository(new GoogleTagManagerReporitory(dependencies));
    }
  }, [odataInstance, serverContext.Permissions]);

  const isAllDependenciesLoaded = useMemo(() => deps && repository !== null, [deps, repository]);

  return [testToken, repository, isAllDependenciesLoaded];
};
